import * as logger from 'loglevel';
import dayjs from 'dayjs';
import axiosWrapper from '../../helpers/axiosWrapper';
import { journeyTypeSherpa } from '../../helpers/utils';
import { buildQuery, buildQuerySmartvel } from './utils/utils';
import { NO_DURATION_DEFINED } from '../../helpers/axiosWrapper/cache';

/**
 * Makes sure the travel info response is complain with a basic schema
 * @param {*} travelResponseRaw
 */
const validateTravelResponseSmartvel = (travelResponseRaw) => {
  const validation = { isValid: true, message: '' };
  if (travelResponseRaw.results && !Array.isArray(travelResponseRaw.results)) {
    return {
      isValid: false,
      message:
        'INTEGRATION__TRAVEL_RESTRICTIONS: Restriction SCHEMA is invalid, please check Fares API documentation.'
    };
  }
  return validation;
};

/**
 * Makes sure the travel info response is complain with a basic schema
 * @param {*} travelResponseRaw
 */
const validateTravelResponse = (travelResponseRaw) => {
  const validation = { isValid: true, message: '' };
  if (travelResponseRaw.included && !Array.isArray(travelResponseRaw.included)) {
    return {
      isValid: false,
      message:
        'INTEGRATION__TRAVEL_RESTRICTIONS: Restriction SCHEMA is invalid, please check Fares API documentation.'
    };
  }
  if (
    travelResponseRaw.included &&
    travelResponseRaw.included.length > 0 &&
    (!travelResponseRaw.included[0].id || !travelResponseRaw.included[0].type)
  ) {
    return {
      isValid: false,
      message:
        'INTEGRATION__TRAVEL_RESTRICTIONS: Restriction SCHEMA is invalid, please check Fares API documentation.'
    };
  }
  return validation;
};

const getData = (filters) => {
  const {
    origin,
    destination,
    flightType,
    dateRange: { start, end }
  } = filters;
  const departureDate = start === '' ? start : dayjs(start).format('YYYY-MM-DD');
  const segments = [
    {
      segmentType: 'OUTBOUND',
      travelMode: 'AIR',
      origin: {
        airportCode: origin.value
      },
      destination: {
        airportCode: destination.value
      },
      departureDate: departureDate,
      departureTime: '00:00',
      arrivalDate: departureDate,
      arrivalTime: '00:00'
    }
  ];

  if (flightType !== 'ow' && flightType !== 'ONE_WAY') {
    const returnDate = end === '' ? end : dayjs(end).format('YYYY-MM-DD');
    segments.push({
      segmentType: 'RETURN',
      travelMode: 'AIR',
      origin: {
        airportCode: destination.value
      },
      destination: {
        airportCode: origin.value
      },
      departureDate: returnDate,
      departureTime: '00:00',
      arrivalDate: returnDate,
      arrivalTime: '00:00'
    });
  }
  if (filters.fullyVaccinated !== '') {
    const travellers = [{ vaccinations: [{ type: 'COVID_19', status: filters.fullyVaccinated }] }];
    return {
      data: {
        type: 'TRIP',
        attributes: {
          category: journeyTypeSherpa()[flightType],
          segments,
          travellers
        }
      }
    };
  }

  return {
    data: {
      type: 'TRIP',
      attributes: {
        category: journeyTypeSherpa()[flightType],
        segments
      }
    }
  };
};

const getType = (itemType) => {
  switch (itemType) {
    case 'ORIGIN_DOCUMENTS': {
      return 'DESTINATION_DOCUMENTS';
    }
    case 'ORIGIN_TRAVEL_RESTRICTIONS': {
      return 'DESTINATION_TRAVEL_RESTRICTIONS';
    }
    default:
      return itemType;
  }
};

const fillingInfo = (data, dataRaw, categoriesList) => {
  const resp = [];
  data.forEach((item) => {
    const included = item.included;
    included.forEach((element) => {
      const id = element.id;
      dataRaw.forEach((e) => {
        if (id === e.id) {
          resp.push({
            type: getType(item.type),
            ...e.attributes
          });
        }
      });
    });
  });
  let finallyResp = [];
  let restrictionByCategory = [];
  let index = 0;
  categoriesList.forEach((element) => {
    resp.forEach((item) => {
      if (element === item.type) {
        restrictionByCategory.push({
          index: index++,
          ...item
        });
      }
    });
    if (restrictionByCategory.length > 0) {
      finallyResp.push({ type: element, data: [...restrictionByCategory] });
    }
    restrictionByCategory = [];
    index = 0;
  });
  return finallyResp;
};

const alertIconType = {
  LEVEL_1: 'check',
  LEVEL_2: 'warning',
  LEVEL_3: 'close'
};

const categoriesList = [
  'DESTINATION_TRAVEL_RESTRICTIONS',
  'ORIGIN_TRAVEL_RESTRICTIONS',
  'DESTINATION_DOCUMENTS',
  'LOCAL_RESTRICTIONS',
  'ORIGIN_DOCUMENTS'
];

const getImportantCategories = (outbound) => {
  return outbound.summary.groupings.filter((item) =>
    categoriesList.find((category) => category === item.type)
  );
};

// const enforcementMapperR = [
//   'NOT_REQUIRED_SMARVEL',
//   'MAY_BE_REQUIRED_SMARVEL',
//   'REQUIRED_SMARVEL',
//   'NOT_INFO_SMARVEL'
// ];
// const enforcementMapperA = [
//   'ALLOWED_SMARVEL',
//   'MAY_BE_ALLOWED_SMARVEL',
//   'NOT_ALLOWED_SMARVEL',
//   'NOT_INFO_SMARVEL'
// ];

export const vaccinatedMap = {
  NOT_VACCINATED: 'NOT_VACCINATED',
  FULLY_VACCINATED: 'FULLY_VACCINATED'
};
/**
 * The group routes API returns the data in non linear format
 * so this function will intend normalize the data for the components
 * @param {*} travelResponseRaw
 * @param string flightType: 0: departing, 1: returning
 */
const transformData = (travelResponseRaw) => {
  const {
    data: {
      attributes: {
        category,
        outbound,
        outbound: { summary: summaryOutbound },
        return: returnData
      }
    },
    included
  } = travelResponseRaw;

  const departureCategories = getImportantCategories(outbound);
  /**
   * travelRestriction from outbound
   */
  // const before = outbound.travelRestrictions;
  /**
   * entryRestrictions from return
   * travelRestrictions from return
   */
  // const arrive = outbound.travelRestrictions;
  /**
   * entryRestrictions from outbound
   */
  const returnCategories =
    category === 'ROUND_TRIP'
      ? getImportantCategories(travelResponseRaw.data.attributes.return)
      : [];

  // travelResponseRaw.included.forEach((item) => {
  //   const newItem = {
  //     ...item.attributes,
  //     ...item
  //   };
  //   delete newItem.attributes;
  //   if (newItem.type === 'RESTRICTION') {
  //     if (newItem.subCategory === 'ENTRY') before.push(newItem);
  //   }
  //   if (newItem.type === 'PROCEDURE') {
  //     if (newItem.subCategory === 'BEFORE_ARRIVAL' || newItem.subCategory === 'IN_FLIGHT')
  //       before.push(newItem);
  //     if (newItem.subCategory === 'ON_ARRIVAL' || newItem.subCategory === 'DOMESTIC')
  //       arrive.push(newItem);
  //   }
  // });
  return {
    source: 'Sherpa',
    arrive: fillingInfo(departureCategories, included, categoriesList),
    returning: fillingInfo(returnCategories, included, categoriesList),
    summaryDeparture: {
      msg: summaryOutbound.headline,
      icon: alertIconType[summaryOutbound.travelOpenness]
    },
    summaryReturn: {
      msg: returnData ? returnData.summary.headline : '',
      icon: returnData ? alertIconType[summaryOutbound.travelOpenness] : ''
    },
    country: travelResponseRaw.data.attributes
  };
};

// const getLinks = (item) => {
//   if (item.observations.links.length !== 0) {
//     for (let index = 0; index < item.observations.links.length; index++) {
//       const element = item.observations.links[index];
//       return {
//         title: element.title ?? element.text,
//         url: element.href
//       };
//     }
//   }
//   return;
// };

const getRequiredLabelKeyByCode = (pattern, code) => {
  switch (code) {
    case 0: {
      return `${pattern}-not-required`;
    }
    case 1: {
      return `${pattern}-may-be-required`;
    }
    case 2: {
      return `${pattern}-required`;
    }
    case 3: {
      return `${pattern}-no-info`;
    }
    default: {
      return `${pattern}-no-info`;
    }
  }
};

const getAllowanceLabelKeyByCode = (pattern, code) => {
  switch (code) {
    case 0: {
      return `${pattern}-allowed`;
    }
    case 1: {
      return `${pattern}-may-be-allowed`;
    }
    case 2: {
      return `${pattern}-not-allowed`;
    }
    case 3: {
      return `${pattern}-no-info`;
    }
    default: {
      return `${pattern}-no-info`;
    }
  }
};

const fillingInfoSmartvel = (data, filter) => {
  if (data !== undefined && data !== null) {
    const { fullyVaccinated } = filter;
    let {
      entry_requirements,
      transit_requirements,
      quarantine,
      test,
      forms,
      health_insurance
    } = data;

    let entry_requirements_type_of_icon,
      transit_requirements_type_of_icon,
      quarantine_type_of_icon,
      test_type_of_icon,
      forms_type_of_icon,
      health_insurance_type_of_icon;

    if (fullyVaccinated === vaccinatedMap.NOT_VACCINATED) {
      entry_requirements_type_of_icon = entry_requirements.entry_allowance.current_entry_allowance;
      transit_requirements_type_of_icon =
        transit_requirements.transit_allowance.current_transit_allowance;
      quarantine_type_of_icon = quarantine.quarantine_requirement.current_quarantine_required;
      test_type_of_icon = test.test_requirement.current_test_requirement;
      forms_type_of_icon = forms.forms_requirement.current_form_requirement;
      health_insurance_type_of_icon =
        health_insurance.health_insurance_requirement.current_health_insurance_requirement;

      entry_requirements = getAllowanceLabelKeyByCode(
        'cmp-travel-restrictions-entry-requirements',
        entry_requirements_type_of_icon
      );
      transit_requirements = getAllowanceLabelKeyByCode(
        'cmp-travel-restrictions-transit-requirements',
        transit_requirements_type_of_icon
      );
      quarantine = getRequiredLabelKeyByCode(
        'cmp-travel-restrictions-quarantine',
        quarantine_type_of_icon
      );
      test = getRequiredLabelKeyByCode('cmp-travel-restrictions-test', test_type_of_icon);
      forms = getRequiredLabelKeyByCode('cmp-travel-restrictions-forms', forms_type_of_icon);
      health_insurance = getRequiredLabelKeyByCode(
        'cmp-travel-restrictions-health-insurance',
        health_insurance_type_of_icon
      );
    } else {
      entry_requirements_type_of_icon =
        entry_requirements.vaccinated_entry_allowance.current_entry_allowance;
      transit_requirements_type_of_icon =
        transit_requirements.vaccinated_transit_allowance.current_transit_allowance;
      quarantine_type_of_icon =
        quarantine.vaccinated_quarantine_requirement.current_quarantine_required;
      test_type_of_icon = test.vaccinated_test_requirement.current_test_requirement;
      forms_type_of_icon = forms.vaccinated_forms_requirement.current_form_requirement;
      health_insurance_type_of_icon =
        health_insurance.vaccinated_health_insurance_requirement
          .current_health_insurance_requirement;

      entry_requirements = getAllowanceLabelKeyByCode(
        'cmp-travel-restrictions-entry-requirements',
        entry_requirements_type_of_icon
      );
      transit_requirements = getAllowanceLabelKeyByCode(
        'cmp-travel-restrictions-transit-requirements',
        transit_requirements_type_of_icon
      );
      quarantine = getRequiredLabelKeyByCode(
        'cmp-travel-restrictions-quarantine',
        quarantine_type_of_icon
      );
      test = getRequiredLabelKeyByCode('cmp-travel-restrictions-test', test_type_of_icon);
      forms = getRequiredLabelKeyByCode('cmp-travel-restrictions-forms', forms_type_of_icon);
      health_insurance = getRequiredLabelKeyByCode(
        'cmp-travel-restrictions-health-insurance',
        health_insurance_type_of_icon
      );
    }

    return [
      {
        category: 'entry_requirements',
        labelKeyForText: 'cmp-travel-restrictions-entry-requirements',
        labelKeyForData: entry_requirements,
        typeOfIcon: entry_requirements_type_of_icon,
        typeofOption: 'allowance',
        icon: 'ENTRY_REQUIREMENTS'
      },
      {
        category: 'transit_requirements',
        labelKeyForText: 'cmp-travel-restrictions-transit-requirements',
        labelKeyForData: transit_requirements,
        typeOfIcon: transit_requirements_type_of_icon,
        typeofOption: 'allowance',
        icon: 'TRANSIT_REQUIREMENTS'
      },
      {
        category: 'quarantine',
        labelKeyForText: 'cmp-travel-restrictions-quarantine',
        labelKeyForData: quarantine,
        typeOfIcon: quarantine_type_of_icon,
        typeofOption: 'required',
        icon: 'QUARANTINE'
      },
      {
        category: 'test',
        labelKeyForText: 'cmp-travel-restrictions-test',
        labelKeyForData: test,
        typeOfIcon: test_type_of_icon,
        typeofOption: 'required',
        icon: 'TEST'
      },
      {
        category: 'forms',
        labelKeyForText: 'cmp-travel-restrictions-forms',
        labelKeyForData: forms,
        typeOfIcon: forms_type_of_icon,
        typeofOption: 'required',
        icon: 'FORMS'
      },
      {
        category: 'health_insurance',
        labelKeyForText: 'cmp-travel-restrictions-health-insurance',
        labelKeyForData: health_insurance,
        typeOfIcon: health_insurance_type_of_icon,
        typeofOption: 'required',
        icon: 'HEALTH_INSURANCE'
      }
    ];
  }
  return [];
};

/**
 * The group routes API returns the data in non linear format
 * so this function will intend normalize the data for the components
 * @param {*} travelResponseRaw
 * @param string flightType: 0: departing, 1: returning
 */
const transformDataSmartvel = (travelResponseRaw, filter) => {
  const arriveData = fillingInfoSmartvel(travelResponseRaw[0].results[0], filter);
  const returningData =
    filter.flightType !== 'ow' && filter.flightType !== 'ONE_WAY'
      ? fillingInfoSmartvel(travelResponseRaw[1].results[0], filter)
      : [];
  return {
    source: 'Smartvel',
    arrive: arriveData,
    returning: returningData,
    summaryDeparture: {
      msg: '',
      icon: ''
    },
    summaryReturn: {
      msg: '',
      icon: ''
    }
    // country: travelResponseRaw.data.attributes
  };
};

const getQueryPromise = (optionsQuery, dataApi, params) => {
  return axiosWrapper(
    {
      method: dataApi.method,
      url: `${dataApi.endPoint}?key=${dataApi.auth}${params}`,
      headers: { ...dataApi.headers },
      data: {}
    },
    optionsQuery
  );
};

const makeQuery = (data) => {
  if (
    data?.data?.attributes?.segments?.[0]['departureDate'] === '' ||
    data?.data?.attributes?.segments?.[0]['arrivalDate'] === ''
  ) {
    return false;
  }
  if (data?.data?.attributes?.segments?.length === 2) {
    if (
      data?.data?.attributes?.segments?.[1]['departureDate'] === '' ||
      data?.data?.attributes?.segments?.[1]['arrivalDate'] === ''
    ) {
      return false;
    }
  }
  return true;
};
const getTravelsRestrictionsSherpa = (filter, meta, pageContext, integrationSettings) => {
  return new Promise((resolve, reject) => {
    if (!integrationSettings) {
      const MESSAGE = 'INTEGRATION__FARES: **integrationSettings** not specified.';
      logger.error(MESSAGE);
      reject(MESSAGE);
    }

    let filterCopy = Object.assign({}, filter);
    const data = getData(filterCopy);

    const { v2SherpaAPI } = integrationSettings;
    const { cache = false, cacheDuration = NO_DURATION_DEFINED } = v2SherpaAPI;
    if (
      !v2SherpaAPI ||
      !v2SherpaAPI.method ||
      !v2SherpaAPI.endPoint ||
      !v2SherpaAPI.headers ||
      !v2SherpaAPI.auth
    ) {
      const MESSAGE = `INTEGRATION__FARES: **integrationSettings.v2SherpaAPI** configuration issues.`;
      logger.error(MESSAGE);
      reject(MESSAGE);
    }

    // ISSUE: The languages are limited by the Sherpa API, in addition to not complying
    // with the format that EveryMundo has for languages, that is why the need for this behavior
    // https://www.notion.so/Languages-sherpa-018e1e5bc8af4684a74bd469beb90bf0
    filterCopy.languagesBySiteEdition = filter.languagesBySiteEditionDefault;
    const searchLanguages = filter.languagesBySiteEdition
      .filter((item) => item.siteEdition === filter.siteEdition)
      ?.pop();
    if (searchLanguages) {
      filterCopy.languagesBySiteEdition = searchLanguages.language;
    }

    const params = buildQuery(filterCopy);
    if (makeQuery(data)) {
      axiosWrapper(
        {
          method: v2SherpaAPI.method,
          url: `${v2SherpaAPI.endPoint}?key=${v2SherpaAPI.auth}${params}`,
          headers: { ...v2SherpaAPI.headers },
          data: data
        },
        {
          resource: 'INTEGRATION__TRAVEL__RESTRICTION__GET__ITEMS',
          meta,
          pageContext,
          integrationSettings,
          cache,
          cacheDuration
        }
      )
        .then(({ data }) => {
          const validation = validateTravelResponse(data);
          if (validation.isValid) {
            logger.info('INTEGRATION__TRAVEL__RESTRICTION: Successful request', data);
            const response = transformData(data);
            resolve(response);
          } else {
            logger.error(validation.message, validation.data);
            reject(data);
          }
        })
        .catch((err) => {
          reject(err);
        });
    } else {
      const resolvedProm = Promise.resolve({
        arrive: {},
        returning: {},
        summaryDeparture: { icon: '', msg: '' },
        summaryReturn: { icon: '', msg: '' },
        country: { outbound: {} }
      });
      resolvedProm.then((value) => {
        resolve(value);
      });
    }
  });
};

const getTravelsRestrictionsSmartvel = (filter, meta, pageContext, integrationSettings) => {
  return new Promise((resolve, reject) => {
    if (!integrationSettings) {
      const MESSAGE = 'INTEGRATION__FARES: **integrationSettings** not specified.';
      logger.error(MESSAGE);
      reject(MESSAGE);
    }

    let filterCopy = Object.assign({}, filter);

    const { v4SmartvelAPI } = integrationSettings;
    if (
      !v4SmartvelAPI ||
      !v4SmartvelAPI.method ||
      !v4SmartvelAPI.endPoint ||
      !v4SmartvelAPI.headers ||
      !v4SmartvelAPI.auth
    ) {
      const MESSAGE = `INTEGRATION__FARES: **integrationSettings.v4SmartvelAPI** configuration issues.`;
      logger.error(MESSAGE);
      reject(MESSAGE);
    }

    const params = buildQuerySmartvel(filterCopy);

    const optionsQuery = {
      resource: 'INTEGRATION__TRAVEL__RESTRICTION__GET__ITEMS',
      meta,
      pageContext,
      integrationSettings,
      cache: true
    };

    const { dateRange } = filterCopy;

    if (filter.flightType !== 'ow' && filter.flightType !== 'ONE_WAY') {
      if (dateRange?.start !== '' && dateRange?.end !== '') {
        const params_rt_query = buildQuerySmartvel({
          ...filterCopy,
          origin: filterCopy.destination,
          destination: filterCopy.origin
        });
        const querys = [];
        querys.push(getQueryPromise(optionsQuery, v4SmartvelAPI, params));
        querys.push(getQueryPromise(optionsQuery, v4SmartvelAPI, params_rt_query));
        Promise.all(querys).then((result) => {
          const origin_destination_data = result[0].data;
          const destination_origin_data = result[1].data;
          const validation_origin_destination = validateTravelResponseSmartvel(
            origin_destination_data
          );
          const validation_destination_origin = validateTravelResponseSmartvel(
            destination_origin_data
          );

          if (validation_origin_destination.isValid && validation_destination_origin.isValid) {
            logger.info(
              'INTEGRATION__TRAVEL__RESTRICTION: Successful request',
              origin_destination_data,
              ' ',
              destination_origin_data
            );
            const response = transformDataSmartvel(
              [origin_destination_data, destination_origin_data],
              filter
            );
            resolve(response);
          } else {
            if (!validation_origin_destination.isValid) {
              logger.error(
                validation_origin_destination.message,
                validation_origin_destination.data
              );
              reject(result[0].data);
            }
            if (!validation_destination_origin.isValid) {
              logger.error(
                validation_destination_origin.message,
                validation_destination_origin.data
              );
              reject(result[1].data);
            }
          }
        });
      } else {
        const resolvedProm = Promise.resolve({
          arrive: [],
          returning: [],
          source: 'Smartvel',
          summaryDeparture: { icon: '', msg: '' },
          summaryReturn: { icon: '', msg: '' }
        });
        resolvedProm.then((value) => {
          resolve(value);
        });
      }
    } else {
      if (dateRange?.start !== '') {
        getQueryPromise(optionsQuery, v4SmartvelAPI, params).then(({ data }) => {
          const validation = validateTravelResponseSmartvel(data);
          if (validation.isValid) {
            logger.info('INTEGRATION__TRAVEL__RESTRICTION: Successful request', data);
            const response = transformDataSmartvel([data], filter);
            resolve(response);
          } else {
            logger.error(validation.message, validation.data);
            reject(data);
          }
        });
      } else {
        const resolvedProm = Promise.resolve({
          arrive: [],
          returning: [],
          source: 'Smartvel',
          summaryDeparture: { icon: '', msg: '' },
          summaryReturn: { icon: '', msg: '' }
        });
        resolvedProm.then((value) => {
          resolve(value);
        });
      }
    }
  });
};

/**
 * Retrieve fares from the GroupRoutes Endpoint
 * @param {*} filter
 * @param {*} meta
 * @param {*} integrationSettings
 */
const getTravelsRestrictions = (filter, meta, pageContext, integrationSettings) => {
  const travelRestrictionsSource = filter.travelRestrictionsSource;
  if (travelRestrictionsSource) {
    switch (travelRestrictionsSource.toLowerCase()) {
      case 'sherpa': {
        return getTravelsRestrictionsSherpa(filter, meta, pageContext, integrationSettings);
      }
      case 'smartvel': {
        return getTravelsRestrictionsSmartvel(filter, meta, pageContext, integrationSettings);
      }
      default: {
        return getTravelsRestrictionsSherpa(filter, meta, pageContext, integrationSettings);
      }
    }
  }
  return getTravelsRestrictionsSherpa(filter, meta, pageContext, integrationSettings);
};

export { getTravelsRestrictions, transformData };
